import {Eixo} from "./eixo";

export class Percurso {
    id: number;
    nome: string;
    descricao: string;
    dataInicio: Date;
    dataFim: Date;
    eixo: Eixo;
}
